import { render, staticRenderFns } from "./CatchWordPreview.vue?vue&type=template&id=b5827d84&lang=pug&"
import script from "./CatchWordPreview.vue?vue&type=script&lang=js&"
export * from "./CatchWordPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports